module.exports = __webpack_public_path__ + "static/media/redux.75349fec.png";